import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const NavbarBrand = styled(Link)`
  color: ${props => props.theme.white};
  text-transform: uppercase;
  width: 400px;
  :hover {
    color ${props => props.theme.white};
  }
`;

export const Navbar = styled.header`
  align-items: center;
  background-color: ${props => props.theme.mainColor};
  color: ${props => props.theme.white};
  display: flex;
  font-size: 26px;
  font-weight: bold;
  justify-content: center;
  padding: 30px;
  
  svg {
    width: 40px;
  }

  ul {
    align-items: center;
    color: ${props => props.theme.white};
    display: flex;
    flex-direction: row;
    font-size: 18px;
    justify-content: flex-end;
    list-style-type: none;
    margin-bottom: 0;
    padding: 0;
    width: 100%;

    a {
      color: ${props => props.theme.white};
    }
    
    li {
      padding: 0 15px;
      :not(:last-child) {
        border-right: 2px solid ${props => props.theme.white};
        @media (min-width: 992px) {
          margin-right: 
        }
      }
    }
    
  }

  * {
    color: ${props => props.theme.white}; 
    :hover {  
      color ${props => props.theme.white};
      text-decoration: none;
    }
  }
`;